import { render, staticRenderFns } from "./DocumentsCopy.vue?vue&type=template&id=7a3c4c67&scoped=true&"
import script from "./DocumentsCopy.vue?vue&type=script&lang=js&"
export * from "./DocumentsCopy.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCopy.vue?vue&type=style&index=0&id=7a3c4c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c4c67",
  null
  
)

export default component.exports